export type DataDogRumProperties = {
  setGlobalContextProperty: (
    contextName: string,
    object: Record<string, string> | string | boolean,
  ) => void;
  setUser: (object: Record<string, string | number | undefined>) => void;
  addAction: (actionName: string, object: Record<string, string>) => void;
  addError: (error: unknown, context?: Record<string, unknown>) => void;
};

export enum DD_ACTION {
  SHOP_NOW = 'shop now',
  USER_CARD = 'user card',
  PARTNER_TILE_CLICK = 'partner tile click',
  REGISTER_NEW_CARD = 'add new card',
  REGISTER_NEW_CARD_FAILURE = 'add new card failed',
  REMOVE_CARD_STEP_1 = 'remove card step1',
  REMOVE_CARD_STEP_2 = 'remove card step2',
}
